import React, { useState } from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import { EyeOutlined, EyeFilled } from '@ant-design/icons';
import HttpService from '../services/httpService';

const CdrMaskedPhone = ({ cdrId, field, maskedValue, setSnackInfo }) => {
    const [visible, setVisible] = useState(false);
    const [plainPhone, setPlainPhone] = useState(null);
    const [loading, setLoading] = useState(false);

    if (!maskedValue || maskedValue === 'NA') {
        return 'NA';
    }

    const handleToggle = async () => {
        if (visible) {
            setVisible(false);
            return;
        }

        if (plainPhone) {
            setVisible(true);
            return;
        }

        setLoading(true);
        try {
            const response = await HttpService.viewCdrPhone(cdrId, field);
            if (response?.data?.success) {
                setPlainPhone(response.data.phone);
                setVisible(true);
            } else if (setSnackInfo) {
                setSnackInfo(response?.data?.message || 'Failed to reveal phone number', 'error');
            }
        } catch (error) {
            if (setSnackInfo) {
                setSnackInfo(error?.response?.data?.message || 'Failed to reveal phone number', 'error');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
            {visible && plainPhone ? plainPhone : maskedValue}
            <Tooltip title={visible ? 'Hide number' : 'View number'}>
                <span>
                    <IconButton
                        size="small"
                        onClick={handleToggle}
                        disabled={loading}
                        style={{ padding: 2 }}
                    >
                        {visible ? <EyeFilled /> : <EyeOutlined />}
                    </IconButton>
                </span>
            </Tooltip>
        </span>
    );
};

export default CdrMaskedPhone;
